import React, { useState, useEffect } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getLatestStoredImages, patchCapDefaultMonitor, getCaps, createNeighborhood, changeCapName, changeCapNeighborhood, loadCap, patchCapLightsPolicy } from '../utils/bedrockAPI';
import { storeCap, getUser, getCapTitleLengthClass } from '../utils/Common';
import './CameraSettings.css';
import TimelapseModal from '../components/TimelapseModal';
import SharingModal from '../components/SharingModal';
import ZonesModal from '../components/ZonesModal';
import LightsPolicyModal, { hasLightsPolicyConfig, getDefaultLightsPolicy } from '../components/LightsPolicyModal';

export default function CameraSettings(props) {
  const [cap, setCap] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMounted, setIsMounted] = useState(true);
  const [monitorImages, setMonitorImages] = useState({});
  const [caps, setCaps] = useState(null);
  const [neighborhoods, setNeighborhoods] = useState(null);
  const [capName, setCapName] = useState("");
  const [neighborhoodSelection, setNeighborhoodSelection] = useState("");
  const [newNeighborhood, setNewNeighborhood] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingNeighborhood, setIsEditingNeighborhood] = useState(false);
  const [showNewNeighborhoodInput, setShowNewNeighborhoodInput] = useState(false);
  const [showTimelapseModal, setShowTimelapseModal] = useState(false);
  const [showSharingModal, setShowSharingModal] = useState(false);
  const [sharableCap, setSharableCap] = useState(null);
  const [showZonesModal, setShowZonesModal] = useState(false);
  const [showLightsPolicyModal, setShowLightsPolicyModal] = useState(false);
  const [isConfiguringDefaultLights, setIsConfiguringDefaultLights] = useState(false);

  // Check if user has permission to edit this camera
  const hasEditPermission = () => {
    const user = getUser();
    if (user.role === 'ADMIN') {
      return true;
    }
    if (user.caps && user.caps[cap?.capId] && user.caps[cap.capId].accessType === 'OWNER') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    // accessCap();
    capObject();
    loadCaps();
    return () => {
      setIsMounted(false);
    };
  }, [props.match.params.capid]);

  // Get's CAP object - most importantly - the status
  async function capObject() {
        try {
            var tempCap = await loadCap(props.match.params.capid);
            if(isMounted) {
                storeCap(tempCap);
                setCap(tempCap);
                setCapName(tempCap.name || "");
                setIsLoading(false);
            }
            return tempCap;
        } catch(e) {
            console.log(e);
        }
    }

//   const accessCap = async () => {
//     try {
//       const capData = await getCap(props.match.params.capid);
//       if (isMounted) {
//         console.log(capData);
//         setCap(capData);
//         setCapName(capData.name || "");
//       }
      
//       setIsLoading(false);
//     } catch (error) {
//       console.error('Error loading cap:', error);
//       setIsLoading(false);
//     }
//   };

  const loadCaps = async () => {
    try {
      const tempCaps = await getCaps();
      if (isMounted) {
        setCaps(tempCaps);
      }
    } catch (error) {
      console.error('Error loading caps:', error);
    }
  };

  useEffect(() => {
    async function loadMonitorImages() {
      if (cap && cap.capId) {
        try {
          const images = await getLatestStoredImages(cap.capId);
          if (isMounted) {
            setMonitorImages(images);
          }
        } catch (error) {
          console.error('Error loading monitor images:', error);
        }
      }
    }
    loadMonitorImages();
    if(cap && isMounted) {
        storeCap(cap);
    }
  }, [cap]);

  useEffect(() => {
    const compileNeighborhoods = (capList) => {
      var neighborhoods = []
      neighborhoods.push({null:"Do not assign a Neighborhood"});
      neighborhoods.push({"new":"Create New Neighborhood"});
      for(var i=0; i<capList.length; i++) {
        if(capList[i].neighborhoodid) {
          neighborhoods.push({[capList[i].neighborhoodid]:capList[i].neighborhood});
        }
      }
      return neighborhoods;
    }
    if(caps) {
      setNeighborhoods(compileNeighborhoods(caps));
    }
  },[caps]);

  const handleMonitorSelect = async (capId, monitorId) => {
    try {
      await patchCapDefaultMonitor(capId, monitorId);
      // Update the cap to reflect the new default monitor
      setCap(prevCap => ({
        ...prevCap,
        defaultMonitorId: monitorId
      }));
    } catch (error) {
      console.error('Error setting default monitor:', error);
    }
  };

  const handleConfigureDefaultLights = async () => {
    if (!window.confirm('Enable default light policy for this camera? You can then open Light Settings to adjust it.')) {
      return;
    }
    const defaultPolicy = getDefaultLightsPolicy();
    try {
      setIsConfiguringDefaultLights(true);
      await patchCapLightsPolicy(cap.capId, defaultPolicy);
      setCap(prevCap => ({
        ...prevCap,
        lights: defaultPolicy
      }));
      if (props.setErrorMessage && props.setErrorStatus && props.setShowError) {
        props.setErrorMessage('Default light policy saved for this camera.');
        props.setErrorStatus('success-message');
        props.setShowError(true);
      }
    } catch (error) {
      console.error('Error enabling default light policy:', error);
      if (props.setErrorMessage && props.setErrorStatus && props.setShowError) {
        props.setErrorMessage('Could not enable light policy. Please try again.');
        props.setErrorStatus('error-message');
        props.setShowError(true);
      }
    } finally {
      setIsConfiguringDefaultLights(false);
    }
  };

  const getModelVersion = (architecture) => {
    if (!architecture) return "Unknown";
    if (architecture.includes("MP4 JETSON BROMINE 2CAM")) return "JobSight";
    if (architecture.includes("MP4 JETSON BROMINE 4CAM")) return "JobSight Pro";
    if (architecture.includes("MP4 JETSON BROMINE")) return "Legacy 4 Cam";
    return architecture;
  };

  const handleNameSave = async () => {
    try {
      await changeCapName(cap.capId, capName);
      setCap(prevCap => ({
        ...prevCap,
        name: capName
      }));
      setIsEditingName(false);
    } catch (error) {
      console.error('Error updating cap name:', error);
    }
  };

  const handleNeighborhoodSave = async () => {
    try {
      let neighborhoodId;
      if (neighborhoodSelection === "Create New Neighborhood") {
        const newNeighborhoodData = await createNeighborhood(newNeighborhood);
        neighborhoodId = newNeighborhoodData.neighborhoodId;
      } else if (neighborhoodSelection === "Do not assign a Neighborhood") {
        neighborhoodId = null;
      } else {
        // Find the neighborhood ID from the selection
        for (let i = 0; i < neighborhoods.length; i++) {
          if (Object.values(neighborhoods[i])[0] === neighborhoodSelection) {
            neighborhoodId = Object.keys(neighborhoods[i])[0];
            break;
          }
        }
      }
      
      await changeCapNeighborhood(cap.capId, neighborhoodId);
      setCap(prevCap => ({
        ...prevCap,
        neighborhoodId: neighborhoodId,
        neighborhood: neighborhoodSelection === "Create New Neighborhood" ? newNeighborhood : neighborhoodSelection
      }));
      setIsEditingNeighborhood(false);
      setShowNewNeighborhoodInput(false);
    } catch (error) {
      console.error('Error updating neighborhood:', error);
    }
  };

  const lookUpNeighborhoodId = (neighborhoodName) => {
    for(var i=0; i<neighborhoods.length; i++) {
      if(Object.values(neighborhoods[i])[0]===neighborhoodName) {
        return Object.keys(neighborhoods[i])[0];
      }
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!cap) {
    return <div>Camera not found</div>;
  }

  const statusInfo = (() => {
    switch (cap.health) {
      case 'ONLINE': return { text: 'ONLINE', cls: 'online' };
      case 'POWER_LOSS': return { text: 'POWER OUTAGE', cls: 'power' };
      case 'BATTERY': return { text: 'BATTERY', cls: 'battery' };
      case 'ERROR': return { text: 'CELL SIGNAL WEAK', cls: 'signal' };
      default: return cap.health ? { text: cap.health, cls: 'default' } : null;
    }
  })();

  return (
    <div className="camera-settings">
      <div className="header">
        <nav className="brand-breadcrumb">
          <Link to="/dashboard">Dashboard</Link>
          <span className="brand-breadcrumb-sep">/</span>
          <Link to={`/caps/${cap.capId}`}>{getModelVersion(cap.architecture)}</Link>
          <span className="brand-breadcrumb-sep">/</span>
          <span className="brand-breadcrumb-current">Camera Settings</span>
        </nav>
        <div className="settings-title-row">
          <h1 className={`brand-cap-title ${getCapTitleLengthClass(cap.name)}`}>{cap.name}</h1>
          {statusInfo && (
            <span className={`brand-status-badge brand-status--${statusInfo.cls}`}>
              {statusInfo.text}
            </span>
          )}
        </div>
      </div>

      <div className="camera-info-panel">
        <div className="camera-details">
          <div className="detail-item">
            <strong>Camera Name:</strong>
            {isEditingName ? (
              <div style={{ display: 'flex', gap: '10px', flex: 1 }}>
                <FormControl
                  type="text"
                  value={capName}
                  onChange={(e) => setCapName(e.target.value)}
                  style={{ flex: 1 }}
                />
                <Button className="btn-brand-dark btn-compact" onClick={handleNameSave}>Save</Button>
                <Button className="btn-brand-outline btn-compact" onClick={() => setIsEditingName(false)}>Cancel</Button>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <span>{cap.name}</span>
                {hasEditPermission() && (
                  <Button className="btn-brand-outline btn-compact" onClick={() => setIsEditingName(true)}>Edit</Button>
                )}
              </div>
            )}
          </div>
          <div className="detail-item">
            <strong>Model:</strong> {getModelVersion(cap.architecture)}
          </div>
          <div className="detail-item">
            <strong>Neighborhood:</strong>
            {isEditingNeighborhood ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1 }}>
                <FormControl
                  componentClass="select"
                  value={neighborhoodSelection}
                  onChange={(e) => {
                    setNeighborhoodSelection(e.target.value);
                    setShowNewNeighborhoodInput(e.target.value === "Create New Neighborhood");
                  }}
                >
                  {neighborhoods && neighborhoods.map((nh,i) => (
                    <option key={i}>
                      {nh[Object.keys(nh)[0]]}
                    </option>
                  ))}
                </FormControl>
                {showNewNeighborhoodInput && (
                  <FormControl
                    type="text"
                    placeholder="Enter new neighborhood name"
                    value={newNeighborhood}
                    onChange={(e) => setNewNeighborhood(e.target.value)}
                  />
                )}
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Button className="btn-brand-dark btn-compact" onClick={handleNeighborhoodSave}>Save</Button>
                  <Button className="btn-brand-outline btn-compact" onClick={() => {
                    setIsEditingNeighborhood(false);
                    setShowNewNeighborhoodInput(false);
                  }}>Cancel</Button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <span>{cap.neighborhood || "No neighborhood assigned"}</span>
                {hasEditPermission() && (
                  <Button className="btn-brand-outline btn-compact" onClick={() => setIsEditingNeighborhood(true)}>Edit</Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="action-buttons-panel">
        <div className="action-buttons-grid">
          <Button
            className="btn-brand-outline"
            onClick={() => setShowZonesModal(true)}
            disabled={!(cap && (cap.health==="ONLINE" || cap.health==="BATTERY")) || !hasEditPermission()}
          >
            Edit Zones
          </Button>
          <Button
            className="btn-brand-outline"
            onClick={() => setShowTimelapseModal(true)}
            disabled={!hasEditPermission()}
          >
            Request Timelapse
          </Button>
          <Button
            className="btn-brand-outline"
            onClick={() => {
              setSharableCap(JSON.parse(JSON.stringify(cap)));
              setShowSharingModal(true);
            }}
            disabled={!hasEditPermission()}
          >
            Share Camera
          </Button>
          {hasLightsPolicyConfig(cap.lights) && (
            <Button
              className="btn-brand-outline"
              onClick={() => setShowLightsPolicyModal(true)}
              disabled={!hasEditPermission()}
            >
              Light Settings
            </Button>
          )}
          {!hasLightsPolicyConfig(cap.lights) && getUser().role === 'ADMIN' && (
            <Button
              className="btn-brand-outline"
              onClick={handleConfigureDefaultLights}
              disabled={isConfiguringDefaultLights}
            >
              {isConfiguringDefaultLights ? 'Saving…' : 'Configure Lights'}
            </Button>
          )}
        </div>
      </div>

      <div className="monitor-selection-panel">
        <h2 className="settings-section-title">Select Your Hero Shot</h2>
        <div className={`monitor-grid ${cap.architecture && (cap.architecture.includes('4CAM') || cap.architecture.includes('MP4 JETSON BROMINE')) ? 'monitor-grid-2x2' : 'monitor-grid-1x4'}`}>
          {monitorImages && Object.entries(monitorImages)
            .filter(([monitorId, monitorData]) => {
              // For 2CAM architecture, only show monitors 1 and 2
              if (cap.architecture && cap.architecture.includes('2CAM')) {
                return monitorData.id <= 2;
              }
              return true;
            })
            .map(([monitorId, monitorData]) => (
            <div 
              key={monitorId}
              className={`monitor-option ${cap.defaultMonitorId === monitorId ? 'selected' : ''} ${!hasEditPermission() ? 'disabled' : ''}`}
              onClick={hasEditPermission() ? () => handleMonitorSelect(cap.capId, monitorId) : undefined}
            >
              <img src={monitorData.url} alt={`Monitor ${monitorData.id}`} />
              <div className="monitor-label">
                Monitor {monitorData.id}
                {cap.defaultMonitorId === monitorId && ' (Default)'}
              </div>
            </div>
          ))}
        </div>
      </div>

      {cap && (
        <TimelapseModal
          show={showTimelapseModal}
          onHide={() => setShowTimelapseModal(false)}
          cap={cap}
          monitorImages={monitorImages}
        />
      )}
      {cap && (
        <SharingModal
          cap={sharableCap}
          show={showSharingModal}
          setErrorMessage={props.setErrorMessage}
          setErrorStatus={props.setErrorStatus}
          setShowError={props.setShowError}
          setShowSharingWindow={setShowSharingModal}
        />
      )}
      {cap && (
        <ZonesModal
          show={showZonesModal}
          onHide={() => setShowZonesModal(false)}
          cap={cap}
          setErrorMessage={props.setErrorMessage}
          setErrorStatus={props.setErrorStatus}
          setShowError={props.setShowError}
        />
      )}
      {cap && hasLightsPolicyConfig(cap.lights) && (
        <LightsPolicyModal
          show={showLightsPolicyModal}
          onHide={() => setShowLightsPolicyModal(false)}
          cap={cap}
          monitorImages={monitorImages}
          setCap={setCap}
          setErrorMessage={props.setErrorMessage}
          setErrorStatus={props.setErrorStatus}
          setShowError={props.setShowError}
        />
      )}
    </div>
  );
} 